import React, { useState } from 'react';

import styled from 'styled-components';

import { initialsOf } from '../../organisms/Interoperability/contractRules';

/**
 * Logo de uma conta parceira (MV2-1713).
 *
 * A URL segue o padrao white-label da plataforma, o mesmo do TenantLogoIcon, do
 * Header e do favicon no useApp:
 * .../white-label/<alias>/images/tenant-alias.png
 *
 * Nao reusa o TenantLogoIcon porque a reserva dele nao serve aqui: quando a imagem
 * falha, ele tenta a URL de OUTRO alias. Isso faz sentido quando os dois candidatos
 * sao do mesmo tenant, mas numa lista de parceiros exibiria o logo de outra
 * empresa — e, se os dois candidatos forem iguais, recarrega a mesma URL que acabou
 * de falhar. Aqui a reserva sao as iniciais, que e o que a lista ja mostrava.
 */

const BASE = 'https://storage.googleapis.com/mk-move-repository/white-label';

export const partnerLogoUrl = (alias: string): string =>
  `${BASE}/${encodeURIComponent(alias)}/images/tenant-alias.png`;

/**
 * Sem moldura nem fundo: o logo ja vem com o proprio recorte, e a borda desenhava
 * um retangulo em volta de imagens que muitas vezes nao sao retangulares.
 */
const Box = styled.span`
  flex: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Initials = styled.span`
  flex: none;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: ${({ theme }) => theme.primary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 11px;
`;

export type PartnerLogoProps = {
  name: string;
  alias: string | null;
};

export const PartnerLogo: React.FC<PartnerLogoProps> = ({ name, alias }) => {
  const [failed, setFailed] = useState(false);

  if (!alias || failed) {
    return <Initials>{initialsOf(name || '')}</Initials>;
  }

  return (
    <Box>
      <Image
        src={partnerLogoUrl(alias)}
        alt={name}
        // Parceiro sem logo no repositorio e o caso comum, nao excecao: a conta
        // pode nunca ter passado por white-label.
        onError={() => setFailed(true)}
      />
    </Box>
  );
};

export default PartnerLogo;
